// eslint-disable-next-line import/prefer-default-export
export const Constants = {
  API_URL: `${import.meta.env.VITE_API_URL ?? "http://localhost:1337/"}/api`,
  ROOT_URL: import.meta.env.VITE_API_URL ?? "http://localhost:1337",
};
